module.exports = __webpack_public_path__ + "static/3-6b5d231af8f6ed171fd3f4e791334dba.jpeg";